import PageLoader from 'components/pageLoader'
import type { CurrencyContextValue } from 'lib/contexts/currency.context'
import CurrencyContext from 'lib/contexts/currency.context'
import type { ICurrency } from 'lib/helpers'
import { loadCurrencies } from 'lib/services/currency.service'
import { useEffect, useMemo, useState, type JSX } from 'react'

export const UnitedStatesDollar: Record<string, ICurrency> = {
	USD: {
		symbol: '$',
		name: 'United States Dollar',
		code: 'USD'
	}
}

export interface CurrencyProviderProperties {
	children: React.ReactNode
}

export const DefaultCurrency = UnitedStatesDollar

const CurrencyProvider: React.FC<CurrencyProviderProperties> = (
	property
): JSX.Element => {
	const { children } = property
	const [currencies, setCurrencies] =
		useState<Record<string, ICurrency>>(UnitedStatesDollar)
	const [isLoading, setIsLoading] = useState<boolean>(true)

	const memoizedValue: CurrencyContextValue = useMemo(
		() => ({ currencies, setCurrencies }),
		[currencies]
	)

	useEffect(() => {
		setIsLoading(true)
		loadCurrencies()
			.then(r => {
				setCurrencies(r)
			})
			.catch((error: unknown) => console.error(error))
			.finally(() => {
				setIsLoading(false)
			})
	}, [])

	return (
		<CurrencyContext.Provider value={memoizedValue}>
			{isLoading ? <PageLoader /> : children}
		</CurrencyContext.Provider>
	)
}

export default CurrencyProvider
